[
    {
        "name": "Texas",
        "abbreviation": "TX"
    }
]